export default "__VITE_ASSET__BQrKxvzO__"